module.exports = __webpack_public_path__ + "static/media/sad.9d472349.png";